export const LIST_PATIENT_MANAGEMENT_TYPE_REQUEST = 'LIST_PATIENT_MANAGEMENT_TYPE_REQUEST'
export const LIST_PATIENT_MANAGEMENT_TYPE_SUCCESS = 'LIST_PATIENT_MANAGEMENT_TYPE_SUCCESS'
export const LIST_PATIENT_MANAGEMENT_TYPE_FAIL = 'LIST_PATIENT_MANAGEMENT_TYPE_FAIL'